<template>
<div class="container-fluid">
	<toolbar>
		<router-link :to="backLink.link" class="btn btn-link">
			<i class="fa fa-caret-left fa-2x"></i>
			<h2>{{backLink.heading}}</h2>
		</router-link>

		<div class="controls" v-if="$route.params.slug != 'new'">
			<nav-tabs :tabs="tabs"
				:active-index="activeTabIndex"
				v-on:tabClick="tabClick">
			</nav-tabs>
		</div>
	</toolbar>
	<collapsible-panel v-if="$route.params.slug != 'new' && activeTabSlug != 'files'" panel-size="xxxl" :always-open="true">
		<template slot="panel">
			<customer-asset-edit-form
				:record="asset"
				:asset-slug="$route.params.slug"
				:is-form="true"
				:prefilled-fields="prefilledFields"
				v-on:assetFetched="setAsset">

				<h2>Details</h2>
			</customer-asset-edit-form>
		</template>
		<template v-if="$route.params.slug == 'new'" slot="main">
			
			<p>Please save the new asset</p>

		</template>
		<template v-else-if="activeTabSlug == 'log'" slot="main">
			<div class="d-flex flex-row align-items-center justify-content-between">

				<h2>Maintenance Log</h2>

				<div v-if="$route.params.slug != 'new'">
					<button class="btn btn-success" v-on:click="newLogEntry">
						<i class="fa fa-plus"></i>
						Add Entry
					</button>
				</div>
			</div>

			<table-list record-name="Maintenance Record"
				:records="mutatedLogs"
				:fields="maintenanceFields"
				:has-edit="true"
				:clickable-row="true"
				:sortable="true"
				:hide-record-count="true"
				v-on:modelChange="fetchMaintenanceLogs"
				v-on:edit="editMaintenanceLog">
			</table-list>
		</template>

		<template v-else-if="activeTabSlug == 'parts'" slot="main">

			<template v-if="!showPartsHistory">

				<div class="d-flex justify-content-between align-items-center">
					<h2 class="m-0">Parts</h2>

					<div>
						<a class="mr-3" href="#" v-on:click.prevent="showPartsHistory = true">View History</a>

						<button type="button" class="btn btn-primary btn-sm" v-on:click="materialSelectorModalVisible = true">
							<i class="fa fa-plus"></i>
							Add Part
						</button>
					</div>
				</div>

				<table-list
					record-name="Part"
					:records="assetMaterials"
					:fields="[
						{ label: 'Description',  key: 'description' },
						{ label: 'Part Number',  key: 'part_number',  align: 'right' }
					]"
					:sortable="true"
					:hide-record-count="true"
					:has-delete="true"
					v-on:delete="removeMaterial">
				</table-list>
			</template>

			<template v-else>

				<div class="d-flex justify-content-between align-items-center">
					<h2 class="m-0">Parts History</h2>
					<i class="fa fa-times icon-button" v-on:click="showPartsHistory = false"></i>
				</div>

				<table-list
					record-name="Part"
					:records="mutatedPartLogs"
					:fields="partsLogsFields"
					:has-edit="true"
					:clickable-row="true"
					:sortable="true"
					:hide-record-count="true"
					v-on:modelChange="fetchMaintenanceLogs"
					v-on:edit="editMaintenanceLog">
				</table-list>
			</template>

		</template>

		<template v-else-if="activeTabSlug == 'location'" slot="main">
			<h2>Asset Location</h2>

			<location-selector
				v-if="asset && currentLocation"
				:initial-values="initialLocationValues"
				v-on:change="setAssetLocation">
			</location-selector>
		</template>

		<template v-else-if="activeTabSlug == 'images'" slot="main">
			<h2>Images</h2>

			<image-thumb-list
				:images="mutatedAssetImages"
				max-size="150px"
				:show-user="true"
				v-on:rotate="rotateImage"
				v-on:deleteImg="deleteAssetImage">

				<div style="display: inline-block;">
					<upload-field 
						style="width:150px;height: 150px;"
						:icons="['fa-plus','fa-image']"
						target="UploadImage/save"
						style-type="box"
						multiple="multiple"
						v-on:uploaded="assetImageUploaded($event,'before')">		
					</upload-field>
				</div>
			</image-thumb-list>
		</template>

		<template v-else-if="activeTabSlug == 'forms'" slot="main">
			<forms-tab
				v-if="asset"
				title="Company Forms for Asset"
				:no-filter-panel="true"
				:customer-id="asset.contact_id"
				:asset-id="asset.id">		
			</forms-tab>
		</template>
	</collapsible-panel>

	<job-files v-else-if="$route.params.slug != 'new' && activeTabSlug == 'files'" store-location="customerAsset" :only-files="true" :parent-record-slug="$route.params.slug" parent-resource="CustomerAsset"></job-files>

	<customer-asset-edit-form v-else
		:asset-slug="$route.params.slug"
		:is-form="true"
		:prefilled-fields="prefilledFields"
		v-on:assetFetched="setAsset">

		<h2>New Customer Asset</h2>

	</customer-asset-edit-form>

	<equipment-maintenance-log-edit-modal :record="maintenanceEditModal.record"
		:visible="maintenanceEditModal.visible"
		:equipment-item="asset"
		:is-customer-asset="true"
		v-on:closeModal="maintenanceEditModal.visible = false"
		v-on:saved="fetchMaintenanceLogs">
	</equipment-maintenance-log-edit-modal>

	<material-selector-modal
		:visible="materialSelectorModalVisible"
		:disable-manual="false"
		:disable-assemblies="true"
		:disable-price="true"
		:disable-qty="true"
		:disable-serial-num="true"
		:disable-warranty="true"
		:expenseLogPrompt="false"
		v-on:addMaterials="addMaterials"
		v-on:closeModal="materialSelectorModalVisible = false">
	</material-selector-modal>
</div>
</template>

<script>
import Toolbar from "@/layout_fragments/Toolbar"

import TableList from "@/components/TableList"
import Pagination from "@/components/Pagination"
import FormGroup from "@/components/FormGroup"

import NavTabs from "@/layout_fragments/NavTabs"
import CollapsiblePanel from "@/layout_fragments/CollapsiblePanel"

import MaterialSelectorModal from "@/components/super_components/MaterialSelectorModal"
import ImageThumbList from "@/components/ImageThumbList"
import UploadField from "@/components/UploadField"
import LocationSelector from "@/components/super_components/LocationSelector"

import CustomerAssetEditForm from "@/components/super_components/CustomerAssetEditForm"
import FormsTab from "@/components/super_components/FormsTab"
import JobFiles from "@/pages/project/JobFiles"

import EquipmentMaintenanceLogEditModal from "@/components/super_components/EquipmentMaintenanceLogEditModal"

export default {
	components: {
		Toolbar,
		CollapsiblePanel,
		Pagination,
		TableList,
		CustomerAssetEditForm,
		MaterialSelectorModal,
		ImageThumbList,
		UploadField,
		FormGroup,
		NavTabs,
		FormsTab,
		JobFiles,
		LocationSelector,
		EquipmentMaintenanceLogEditModal
	},
	data() {
		return {
			asset: null,
			assetImages: [],
			assetFiles: [],
			assetMaterials: [],
			maintenanceLogs: [],
			deleteConfirmVisible: false,
			maintenanceFields: [
				{ label: "Date",              key:"maintenanceDate" },
				{ label: "Work Type",         key:"work_type" },
				{ label: "Work Done",         key:"workDoneShort" },
				{ label: "Work Completed By", key: "workCompletedBy" },
				{ label: "Log Type", 			key: "logType" }
			],
			partsLogsFields: [
				{ label: "Date",               key:"maintenanceDate" },
				{ label: "Service #",          key:"jobNum" },
				{ label: "Part Description",   key:"partDescription" },
				{ label: "Part Number",        key:"partNumber" },
				{ label: "Serial #",           key:"partSerialNum" },
				{ label: "Work Type",          key:"work_type" },
				{ label: "Warranty Expiry",    key:"partWarrantyExpiry" }
			],
			maintenanceEditModal: {
				visible: false,
				record: {},
				editingDoneBy: false,
				updateLastServiceFields: true,
				logFiles: [],
			},
			activeTabIndex: 0,
			showPartsHistory: false,
			materialSelectorModalVisible: false,
			currentLocation: null
		}
	},
	computed: {
		initialLocationValues() {
			let values = {
				location_type: 'address'
			}

			const addressFields = ['suite', 'address', 'city', 'province', 'country', 'postal_code']
			const pinFields = ['lat', 'long']
			const allFields = ['location_type', ...addressFields, ...pinFields]

			let hasAddressField = false

			if (this.asset) {

				// Pre-populate with asset fields
				allFields.forEach(key => {

					if (key in this.asset && this.asset[key] &&            // Key is valid
						(!pinFields.includes(key) || +this.asset[key]))     // If the key is long/lat, it is also not zero
					{
						values[key] = this.asset[key]

						if (addressFields.includes(key))
							hasAddressField = true
					}
				})

				// Fill in any that aren't filled in already
				if ('ContactLocation' in this.asset && this.asset.ContactLocation) {
					addressFields.forEach(key => {

						if (!(key in values) && key in this.asset.ContactLocation && this.asset.ContactLocation[key] &&    // Key is valid and has not been set yet
							(!pinFields.includes(key) || +this.asset.ContactLocation[key]))                                 // If the key is long/lat, it is also not zero
						{

							values[key] = this.asset.ContactLocation[key]
							hasAddressField = true
						}
					})
				}

				// Fill in any that aren't filled in already
				if ('Contact' in this.asset && this.asset.Contact) {
					addressFields.forEach(key => {

						if (!(key in values) && key in this.asset.Contact && this.asset.Contact[key] &&    // Key is valid and has not been set yet
							(!pinFields.includes(key) || +this.asset.Contact[key]))                         // If the key is long/lat, it is also not zero
						{

							values[key] = this.asset.Contact[key]
							hasAddressField = true
						}
					})
				}
			}

			if ((!('lat' in values) || !values.lat || !('long' in values) || !values.long) && this.currentLocation) {
				values.lat = this.currentLocation.lat
				values.long = this.currentLocation.lng

				if (!hasAddressField)
					values.location_type = 'pin'
			}

			// normalize country name, if required
			if (!('country' in values) || values.country.toLowerCase() == 'canada')
				values.country = "CA"

			return values
		},
		backLink() {

			let heading = "Contacts"
			let link = "/contacts"

			if (this.$store.lastRoute && this.$store.lastRoute.indexOf("assets") >= 0) {
				link = this.$store.lastRoute
				heading = "Contact Assets"
			}
			else if (this.asset) {
				heading = "Contact Assets"
				if ("Contact" in this.asset && this.asset.Contact)
					link = '/contact/'+this.asset.Contact.slug+'/assets'
				else if ("ContactLocation" in this.asset && this.asset.ContactLocation && "Contact" in this.asset.ContactLocation && this.asset.ContactLocation.Contact)
					link = "/contact/"+this.asset.ContactLocation.Contact.slug+'/assets'
			}

			return {
				heading,
				link
			}	
		},
		tabs() {
			let vm = this

			return [
				{
					icon: 'fa-wrench',
					label: 'Maintenance Log',
					click: 'log',
					//path: '/contact/asset/'+this.$route.params.slug+"/log",
				},
				{
					icon: 'fa-toolbox',
					label: 'Parts',
					click: 'parts',
					//path: '/contact/asset/'+this.$route.params.slug+"/log",
				},
				{
					icon: 'fa-map-marker',
					label: 'Location',
					click: 'location',
					//path: '/contact/asset/'+this.$route.params.slug+"/log",
				},
				{
					icon: 'fa-image',
					label: 'Images',
					click: 'images'
					//path: '/contact/asset/'+this.$route.params.slug+"/images",
				},
				{
					icon: 'fa-file-image',
					label: 'Files',
					click: 'files'
					//path: '/contact/asset/'+this.$route.params.slug+"/images",
				},
				{
					icon: 'fa-clipboard-check',
					label: 'Forms',
					click: 'forms'
				}
			]
		},
		activeTabSlug() {
			if (this.tabs.length > this.activeTabIndex && this.tabs[this.activeTabIndex])
				return this.tabs[this.activeTabIndex].click
		},
		prefilledFields() {
			return {
				customer_id: "customer_id" in this.$route.params ? this.$route.params.customer_id : null,
				customer_location_id: "customer_location_id" in this.$route.params ? this.$route.params.customer_location_id : null,
				category_id: "category_id" in this.$route.params ? this.$route.params.category_id : null,
			}
		},
		mutatedPartLogs() {
			let logs = []

			this.mutatedLogs.forEach(log => {

				if (!('parts_used_json' in log) || !log.parts_used_json) // skip if no log
					return

				let partsUsed = []

				try {
					partsUsed = JSON.parse(log.parts_used_json)
				} catch (e) {
					return // skip if corrupted log
				}

				partsUsed.forEach(part => {

					// See if it exists in our parts list
					const assetPart = this.assetMaterials.find(p => {
						return ('id' in p && p.id && 'id' in part && part.id && p.id == part.id)
					})

					// Ignore this part if it doesn't exist in our asset parts list
					if (!assetPart)
						return

					let newLog = this.cloneObj(log)

					newLog.partDescription = ""
					if ('description' in part && part.description)
						newLog.partDescription = part.description

					newLog.partNumber = ""
					if ('part_number' in part && part.part_number)
						newLog.partNumber = part.part_number

					newLog.partSerialNum = ""
					if ('serialNum' in part && part.serialNum)
						newLog.partSerialNum = part.serialNum

					newLog.partWarrantyExpiry = ""
					if ('warrantyExpiry' in part && part.warrantyExpiry)
						newLog.partWarrantyExpiry = this.formatDate(part.warrantyExpiry)

					newLog.jobNum = ""
					if ('Service' in log && log.Service && 'job_num' in log.Service && log.Service.job_num)
						newLog.jobNum = log.Service.job_num

					logs.push(newLog)
				})
			})

			return logs
		},
		mutatedAssetImages() {
			let vm = this

			return this.assetImages.map(image => {
				image.thumbUrl = ""
				image.fullUrl = ""

				if ('UploadFile' in image && image.UploadFile) {

					if ('filename' in image.UploadFile && image.UploadFile.filename) {
						image.fullUrl = window.apiRoot+"resources/images/"+vm.$store.sessionToken+"/"+image.UploadFile.filename
						image.thumbUrl =  window.apiRoot+"resources/images/"+vm.$store.sessionToken+"/"+image.UploadFile.filename

					}

					if ('thumb_filename' in image.UploadFile && image.UploadFile.thumb_filename) 
						image.thumbUrl = window.apiRoot+"resources/images/"+vm.$store.sessionToken+"/"+image.UploadFile.thumb_filename
				}

				return image
			})
		},
		maintenanceLogEntryImages() {
			let vm = this

			return this.maintenanceEditModal.images.map(image => {
				image.thumbUrl = window.apiRoot+"resources/images/"+vm.$store.sessionToken+"/"+image.UploadImage.thumb_filename
				image.fullUrl = window.apiRoot+"resources/images/"+vm.$store.sessionToken+"/"+image.UploadImage.filename

				return image
			})
		},
		mutatedLogs() {
			let vm = this
			return this.maintenanceLogs.map(log => {

				if ("work_done" in log && log.work_done) {
					log.logType = "Manual Entry"
					log.workDoneShort = log.work_done.stripTags().substr(0,50)+"..."
				}
				else {
					log.logType = "Worksheet Entry"
					log.workDoneShort = log.work_completed_description.stripTags().substr(0,50)+"..."
				}

				log.work_type = "Work Order"
				if (log.logType == 'Manual Entry')
					log.work_type = log.type

				if ("date_done" in log && log.date_done)
					log.maintenanceDate = vm.formatDate(log.date_done)
				else
					log.maintenanceDate = vm.formatDate(log.created_at)

				log.workCompletedBy = ""
				if ("WorkCompletedBy" in log && log.WorkCompletedBy)
					log.workCompletedBy = log.WorkCompletedBy.first_name+" "+log.WorkCompletedBy.last_name

				return log
			})
		}
	},
	methods: {
		setAssetLocation(location) {

			if (!this.asset)
				return

			// Clone and replace to trigger watch event in asset edit form component
			let clone = this.cloneObj(this.asset)

			Object.keys(location).forEach(key => {
				if (key in clone)
					clone[key] = location[key]
			})

			this.asset = clone
		},
		addMaterials(mats) {
			if (!mats.length)
				return

			const allMaterials = [
				...this.assetMaterials,   // existing materials
				...mats                   // new materials
			]

			this.saveAssetMaterials(allMaterials, "Added part(s)")
		},
		removeMaterial(material, index) {
			let newMaterials = this.cloneObj(this.assetMaterials)
			newMaterials.splice(index, 1)
			this.saveAssetMaterials(newMaterials, "Removed part")
		},
		saveAssetMaterials(mats, alertMsg=false) {
			const vm = this

			const matsJSON = JSON.stringify(mats)

			let payload = {
				id: this.asset.id,
				parts_json: matsJSON
			}

			this.postData('CustomerAsset/save', payload).then(response => {
				if (response.success) {
					vm.materialSelectorModalVisible = false
					vm.assetMaterials = mats
					vm.asset.parts_json = matsJSON

					if (alertMsg)
						vm.alertSuccess(alertMsg)
				}
			})
		},
		tabClick(click) {
			this.activeTabIndex = this.tabs.findIndex(tab => tab.click == click)
			window.history.pushState({},"","/contact/asset/"+this.$route.params.slug+"/"+click)
			this.$forceUpdate()
		},
		setAsset(asset) {
			this.asset = asset

			try {
				this.assetMaterials = JSON.parse(this.asset.parts_json)
			} catch {
				this.assetMaterials = []
			}
		},
		editMaintenanceLog(record) {
			if (record.logType == "Worksheet Entry")
				this.$router.push("/service/"+record.Service.slug+"/worksheet")
			else {
				this.maintenanceEditModal.visible = true

				this.maintenanceEditModal.record = record
				this.maintenanceEditModal.editingDoneBy = false
			}
		},
		assetImageUploaded(response,type) {
			//create the record link to the service

			let vm = this

			let payload = {
				asset_id: this.asset.id,
				file_id: response.data.id,
				is_file: 0
			}

			this.postData("CustomerAssetFile/save",payload,true).then(response => {
				if (response.success) {
					vm.alertSaved("Image uploaded")
					vm.fetchAsset()
				}
			})
		},
		rotateImage(dir,image) {
			let vm = this

			let fileDetails = image
			if ('UploadFile' in image && image.UploadFile)
				fileDetails = image.UploadFile
			else if ('UploadImage' in image && image.UploadImage)
				fileDetails = image.UploadImage

			let payload = {
				rotate_direction: dir,
				id: fileDetails.id
			}

			this.postData("UploadImage/rotate",payload).then(response => {
				image.thumbUrl = window.apiRoot+'resources/images/'+vm.$store.sessionToken+'/'+fileDetails.filename+"?v="+Math.random()

				vm.$forceUpdate()
			})
		},
		deleteAssetImage(image) {
			let vm = this

			let promises = [
				this.postData("CustomerAssetFile/delete",{id:image.id})
			]

			Promise.all(promises).then(responses => {
				vm.fetchAsset()
			})
		},
		newLogEntry() {
			this.maintenanceEditModal.visible = true
			this.maintenanceEditModal.record = {
				in_house: 0,
				LibraryUpload: [],
				work_done: "",
				type: null,
				mileage_or_time: "",
				supplier_id: null,
				date_done: null
			}
			//this.maintenanceEditModal.updateLastServiceFields = false

			this.maintenanceEditModal.editingDoneBy = true
			this.maintenanceEditModal.logFiles = []
		},
		sortLogs() {
			let vm = this
			vm.maintenanceLogs.sort((a,b) => {
				const dateA = "date_done" in a ? vm.moment(a.date_done) : vm.moment(a.created_at);
				const dateB = "date_done" in b ? vm.moment(b.date_done) : vm.moment(b.created_at);

				return dateB.diff(dateA);
			})
		},
		fetchLogEntryImages(log_id) {
			let vm = this

			this.spinner(true)

			let params = {
				filters: [
					["worksheet_id",log_id]
				],
				include: ["UploadImage"]
			}

			this.getJSON("ServiceWorksheetImage/get",params,true).then(response => {
				vm.spinner(false)

				if (response.success) 
					vm.maintenanceEditModal.images = response.data
			})
		},
		fetchMaintenanceLogs() {
			let vm = this

			vm.spinner(true)

			let worksheetParams = {
				filters: [
					["customer_asset_id", this.asset.id]
				],
				include: [
					{ model: "ServiceWorksheetImage", include: "UploadImage" },
					{ model: "Service",               fields:["id", "slug", "job_num"] },
					{ model: "User",                  fields:["id", "slug", "first_name", "last_name"] }
				]
			}

			let logParams = {
				filters: [
					["customer_asset_id", this.asset.id]
				],
				include: [
					{ model: "User", fields:["id", "slug", "first_name", "last_name"] }
				]
			}

			let promises = [
				this.getJSON("ServiceWorksheet/get",worksheetParams,true),
				this.getJSON("AssetMaintenanceLog/get",logParams,true)
			]

			return new Promise((resolve,reject) => {

				Promise.all(promises).then(responses => {
					vm.spinner(false)
					vm.maintenanceLogs = []

					if (responses[0].success)
						vm.maintenanceLogs = responses[0].data

					if (responses[1].success) {
						vm.maintenanceLogs = [
							...vm.maintenanceLogs,
							...responses[1].data
						]
					}

					vm.sortLogs()

					resolve(responses)
				})
			})

		},
		fetchAsset() {
			let vm = this

			let params = {
				include: [
					{
						model: "ServiceWorksheet",
						include: [
							{ model: "ServiceWorksheetImage", include: "UploadImage"},
							{ model: "Service",               fields: ["id", "slug", "job_num"]},
							{ model: "User",                  fields: ["id", "slug", "first_name", "last_name"]}
						],
						page: 1
					},
					{
						model: "AssetMaintenanceLog",
						include: [
							{ model: "User",                  fields: ["id", "slug", "first_name", "last_name"]}
						],
						page: 1
					},
					{
						model: "CustomerAssetFile",
						include: [
							{
								model: "UploadFile",
								include: [
									{
										model: 'User',
										fields: ['first_name', 'last_name']
									}
								]
							}
						]
					},
					{
						model: "ContactLocation",
						include: [{model:"Contact",fields:["id","slug"]}]
					},
					{
						model:"UserAsset",
						include: ["UserLocation"],
					},
					{ model: 'Checklist', fields: ['id'] },
					{ model: 'FormChildTemplate', fields: ['id'] },
					'CustomerAssetTemplate',
					'Contact'
				]
			}

			this.spinner(true)

			this.getJSON("CustomerAsset/find/"+this.$route.params.slug,params).then(response => {
				vm.spinner(false)

				if (response.success) {
					vm.$set(this.$store, "customerAsset", response.data)

					vm.setAsset(response.data)
					vm.assetImages = []
					vm.assetFiles = []

					if ('CustomerAssetFile' in response.data && response.data.CustomerAssetFile) {
						vm.assetImages = response.data.CustomerAssetFile.filter(file => {
							return 'is_file' in file && file.is_file == 0
						})

						vm.assetFiles = response.data.CustomerAssetFile.filter(file => {
							return 'is_file' in file && file.is_file == 1
						})
					}

					vm.maintenanceLogs = []
					if ("ServiceWorksheet" in response.data && response.data.ServiceWorksheet)
						vm.maintenanceLogs = vm.cloneObj(response.data.ServiceWorksheet)

					if ("AssetMaintenanceLog" in response.data && response.data.AssetMaintenanceLog) {
						vm.maintenanceLogs = [
							...vm.maintenanceLogs,
							...response.data.AssetMaintenanceLog
						]
					}

					vm.sortLogs()
				}

			})
		}
	},
	created() {
		if (this.$route.params.slug != 'new') {
			this.fetchAsset()
		}

		this.getLocation().then(location => {
			this.currentLocation = location
		})

		if ("tab" in this.$route.params) 
			this.activeTabIndex = this.tabs.findIndex(tab => tab.click == this.$route.params.tab)
	}
}
</script>